import { i18n } from '@/plugins/i18n'

export const genderTypes = {
    FEMALE: 0,
    MALE:   1,
} 

export const genderTypesStr = {
    FEMALE: i18n.t('label.female'),
    MALE:   i18n.t('label.male'),

    get(gender) {
        let gender_str = null;

        Object.keys(genderTypes).forEach((item, index) => {
            if(genderTypes[item] === gender) {
                gender_str = genderTypesStr[item];
            }
        });

        return gender_str;
    }
}
